import React, { useState } from "react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router";
export default () => {
  const [currentPage, setCurrentPage] = useState(1);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const localThumbnailImgurl = "uploads/events/thumbnail";
  const fetchJobsData = async ({ queryKey }) => {
    const [, page] = queryKey;
    const accessToken = localStorage.getItem("accessToken");
    const { data } = await axios.get(`${baseURL}/api/v2/events?page=${page}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return data?.data;
  };

  const {
    data: eventsData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["eventsData", currentPage],
    queryFn: fetchJobsData,
    keepPreviousData: true,
  });

  const { has_more_pages, total_pages } = eventsData || {};

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading events: {error.message}</p>
      </div>
    );
  }
  const handleEvents = (id) => {
    navigate(`/event-details/${id}`);
  };
  const formatEventDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: "numeric", month: "short", day: "2-digit" };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };
  return {
    currentPage,
    setCurrentPage,
    baseURL,
    localThumbnailImgurl,
    eventsData,
    isLoading,
    handleEvents,
    formatEventDate,
    total_pages,
    has_more_pages,
  };
};
